<template>
    <div class="background">
        <form class="login" @submit.prevent="">
            <v-container fluid fill-height class="loginOverlay">
                <v-layout flex align-center justify-center>
                    <v-flex xs12 sm4 elevation-6>
                        <v-toolbar class="">
                            <v-toolbar-title class="headline text-uppercase "><h4><span
                                    style="color: #21398d;"><b>WTO </b></span>
                                <span class="font-weight-light">LabelManager</span></h4></v-toolbar-title>
                        </v-toolbar>
                        <v-card>
                            <v-card-text class="pt-4">
                                <div>
                                    <v-form v-model="valid" ref="form">
                                        <v-text-field
                                                label="Enter your e-mail address"
                                                v-model="email"
                                                :rules="emailRules"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                label="Enter your password"
                                                v-model="password"
                                                min="8"
                                                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                                                :append-icon-cb="() => (e1 = !e1)"
                                                :type="e1 ? 'password' : 'text'"
                                                :rules="passwordRules"
                                                counter
                                                required
                                        ></v-text-field>
                                        <v-layout justify-space-between>
                                            <v-btn color="primary" @click="login"
                                                   :class=" { 'blue darken-4 white--text' : valid, disabled: !valid }">
                                                Login
                                            </v-btn>
                                        </v-layout>
                                    </v-form>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </form>
    </div>
</template>
<style>
    .background {
        width: 100%;
        height: 90vh;
        background-image: url('~@/../public/img/background.jpg');
        background-size: cover;
        overflow: hidden;
    }
</style>
<script>
    import store from './../store';

    export default {
        store,
        name: 'Login',
        data() {
            return {
                email: '',
                password: '',
                valid: false,
                e1: true,
                passwordRules: [
                    (v) => !!v || 'Password is required',
                ],
                emailRules: [
                    (v) => !!v || 'E-mail is required',
                    (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                ],
            }
        },
        computed: {
            isAuthenticated: function () {
                return this.$store.getters.isAuthenticated()
            },
        },
        methods: {
            login: function () {
                let user = {};
                user.email = this.email;
                user.password = this.password;
                this.$store.dispatch('login', {user});
                // this.$auth.login({ email, password }).then(function (response) {
                //     this.$store.token = response.data.token;
                //     // Execute application logic after successful login
                // })
            },
            register: function () {
                this.$auth.register({name, email, password}).then(function () {
                    // Execute application logic after successful registration
                })
            }
        }
    }
</script>
